module.exports = __webpack_public_path__ + "static/img/15.953306b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/15.png
// module id = 8zaN
// module chunks = 0